import * as XLSX from 'xlsx-js-style'
import { styleTableSheet } from 'utils/excelStyle'
import * as FileSaver from 'file-saver'
import moment from 'moment'

export async function exportToExceTrx(
  items,
  columns,
  summary,
  fileName = 'export',
  onProgress,
  dataTrx,
  exportType = 'Standar',
) {
  const total = Array.isArray(items) ? items.length : 0
  if (!Array.isArray(items) || total === 0) {
    alert('Tidak ada data untuk diexport')
    return
  }

  if (onProgress) onProgress({ fetched: total, total })

  const header = columns.map((c) => {
    const name = typeof c.name === 'string' ? c.name : c.name?.props?.children
    return name ?? 'Kolom'
  })

  const rows = []

  const processedItems = items.map((item) => {
    if (
      item?.escrowpayment?.expiredDate &&
      item?.escrowpayment?.status === 'NEED_CONFIRM_BY_SELLER'
    ) {
      if (moment(item.escrowpayment.expiredDate).isBefore(moment())) {
        return { ...item, status: 'Expired' }
      }
    }
    return item
  })

  const isStandar =
    exportType === 'Standar' ||
    String(fileName || '').toLowerCase().includes('standar')

  processedItems.forEach((row) => {
    const itemDetails = Array.isArray(row?.itemDetail) ? row.itemDetail : []

    // Untuk export Standar: 1 transaksi = 1 baris Excel (tidak dipecah per item)
    if (isStandar) {
      rows.push(
        columns.map((c) => (c.selector ? (c.selector(row) ?? '-') : '-')),
      )
      return
    }

    // Untuk export Detail dan Grouping: dipecah per rincian itemDetail
    if (itemDetails.length > 0) {
      itemDetails.forEach((detailItem, index) => {
        const fakeRow = {
          ...row,
          itemDetail: [detailItem],
          itemDetailVolume: index === 0 ? row?.itemDetailVolume : undefined,
        }
        rows.push(
          columns.map((c) =>
            c.selector ? (c.selector(fakeRow) ?? '-') : '-',
          ),
        )
      })
      return
    }

    rows.push(columns.map((c) => (c.selector ? (c.selector(row) ?? '-') : '-')))
  })

  if (summary) {
    const formatNum = (num, minFrac = 0) => {
      if (num === null || num === undefined) return '0'
      return new Intl.NumberFormat('id-ID', {
        minimumFractionDigits: minFrac,
        maximumFractionDigits: minFrac,
      }).format(num)
    }
    
    rows.push([])
    rows.push([
      'Total:',
      `${formatNum(summary?.totalQty ?? summary?.totalUnitAmount ?? summary?.totalKgAmount ?? 0, 2)} Unit (${formatNum(summary?.totalCommodities ?? summary?.totalItemDetailCount ?? 0, 0)} Barang)`,
      `Rp ${formatNum(summary?.totalAmount ?? summary?.totalTransaction ?? 0, 0)}`
    ])
  }

  const wsData = XLSX.utils.aoa_to_sheet([header, ...rows])
  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, styleTableSheet(wsData), 'transaksi')

  const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
  const finalData = new Blob([excelBuffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
  })
  FileSaver.saveAs(
    finalData,
    `${fileName}_${moment().format('DD-MM-YYYY')}.xlsx`,
  )
}
